<template>
  <div>
    <!--    <ImprovementStatusPortlet></ImprovementStatusPortlet>-->
    <portlet
        :icon="'fas fa-users portlet-icon'"
        :title="$t('engagement.companyengagement')"
        :actions-block="true"
        :fullheight="true"
        class="portlet-pt-20"
    >
      
      <template slot="portletBody">
      
      </template>
    </portlet>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {dataTables} from "../../mixins/dataTables";
import {swalJobs} from "../../mixins/swalJobs";
import CustomTableFilters from "../../components/jobs/CustomTableFilters";
import Datepicker from "vuejs-datepicker";
import {en} from "vuejs-datepicker/dist/locale";
import icons from "@/mixins/improvements/icons";

import jobMethods from "../../mixins/jobs/jobMethods";
import timeCalc from "../../mixins/timeCalc";

import ImprovementStatusPortlet from "@/components/improvements/ImprovementStatusPortlet";

const statusSorting = {
  "created": 1,
  "pending": 2,
  "approved": 3,
  "plan": 4,
  "check": 5,
  "do": 6,
  "act": 7,
  "denied": 8,
  "done": 9
}
export default {
  name: "Improvements",
  mixins: [dataTables, swalJobs, jobMethods, timeCalc, icons],
  components: {
    Datepicker,
    CustomTableFilters,
    ImprovementStatusPortlet,
  },
  data() {
    return {
      en: en,
      time: moment(),
      assignedTo: null,
      loadingJobs: true,
      filterOpen: true,
      filterOpenClass: "m-hide-lg",
      searchUid: "",
      searchActivity: "",
      showDaterangeHelp: false,
      picker: {
        startDate: new Date(),
        endDate: new Date(),
      },
      customFilters: [
        {
          filter: "dateRangeFilter",
          keyToFilter: "created_at",
          options: {
            range: {
              min: null,
              max: null,
            },
          },
        },

        {
          filter: 'arrayContains',
          keyToFilter: 'userId',
          options: {
            values: []
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'status',
          options: {
            values: []
          }
        },
      ],
    };
  },
  computed: {
    ...mapGetters("company", ["getConfig", "getActivities"]),
    ...mapGetters("improvements", ["getImprovements"], ["getMyUnseenAssignedImprovements"]),

    ...mapGetters("users", [
      "getSelectedWorkflow",
      "getMe",
      "getClaims",
      "getRunningJob",
      "getOrderlineWorkflowProduct",
      "getSelectedWorkflowLength",
    ]),
    getImprovementsFiltered() {
      let assignedTo = this.assignedTo
      return _.filter(this.getImprovements, improvement => {
        if (assignedTo) {
          if (improvement.assignedUser.uid) {
            return improvement.assignedUser.uid === this.getMe.uid
          }
        } else {
          return improvement
        }
      })
    },
    getColumns() {
      let self = this;
      let showDeleteButton = self.getClaims.admin;
      const me = this.getMe
      return [
        {
          data: null,
          name: this.$t("improvements.table.view"),
          width: "1%",
          responsivePriority: 1,
          visible: true,
          render: function (data) {
            let html = `<a data-to="/improvements/${data.id}" class="action-icon dt-router-link"><i title="view" class="far fa-eye"></i></a>`
            html += data.assigneeHasNotSeen === me.id ? '<i class="far fa-bell" style="color: #00c9ff; font-size: 1.5rem; padding: 0 6px;"></i>' : ''

            if (data.title) {
              return html

            }
            return " ";
            // return `<a data-to="/start-stop/${data.job.id}" class="action-icon dt-router-link"><i title="view" class="far fa-eye"></i></a>`;
          },
        },
        {
          data: null,
          name: this.$t("improvements.table.likes"),
          width: "1%",
          responsivePriority: 1,
          visible: true,
          render: function (data, type) {
            if (data.likes) {
              return data.likes.length;
            }
            if (type.sort) {
              return 0;
            }
            return "";
            // return `<a data-to="/start-stop/${data.job.id}" class="action-icon dt-router-link"><i title="Aanpassen" class="far fa-eye"></i></a>`;
          },
        },
        {
          data: 'status',
          name: this.$t("improvements.improvement.status"),
          width: "1%",
          responsivePriority: 1,
          visible: true,
          render: function (data, type) {
            if (type == 'sort') {
              return statusSorting[data]
            }
            let icon = self.getIcon(data);
            return `<span  class="badge badge-primary  w-100" style="background:${icon.textColor}">${icon.text} </span>`;

            // return `<a data-to="/start-stop/${data.job.id}" class="action-icon dt-router-link"><i title="Aanpassen" class="far fa-eye"></i></a>`;

          }


        },
        {
          data: null,
          name: this.$t("improvements.table.improvement"),
          width: "70%",
          responsivePriority: 1,
          visible: true,
          render: function (data) {
            return data.improvement ? data.improvement : data.title;
          },
        },
        {
          data: null,
          name: this.$t("improvements.table.assigned"),
          width: "2%",
          responsivePriority: 1,
          visible: true,
          render: function (data) {
            if (data.assignedUser && data.assignedUser.name) {
              return data.assignedUser.name;
            } else {
              return null;
            }

          },
        },
        {
          data: "userName",
          name: this.$t("improvements.table.user"),
          width: "2%",
          responsivePriority: 1,
          visible: true,
        },
        {
          data: "created_at",
          name: this.$t("improvements.table.date"),
          width: "2%",
          responsivePriority: 1,
          visible: true,
          render: function (data) {
            return moment(data).format("DD-MM-YY");
          },
        },
        {
          data: "updated_at",
          name: this.$t("improvements.table.updated"),
          width: "2%",
          responsivePriority: 1,
          visible: true,
          render: function (data) {
            if (data != null) return moment(data).format("DD-MM-YY");
            else return "";
          },
        },
        {
          data: null,
          name: "Options",
          searchable: false,
          orderable: false,
          width: "5%",
          visible: showDeleteButton,
          responsivePriority: 1,
          render(data) {
            return showDeleteButton
                ? `<a href='javascript:'  class="btn btn-danger delete-improvement text-center"><i class="fas fa-trash  delete-improvement"></i></a>`
                : "";
          },
        },
      ];
    },
    //@vuese
    // Gets disabled dates To
    getDisabledDatesTo() {
      return {
        to: new Date(this.customFilters[0].options.range.min), // Disable all dates up to specific date
      };
    }
    ,
    //@vuese
    // Gets disabled dates From
    getDisabledDatesFrom() {
      return {
        from: new Date(this.customFilters[0].options.range.max), // Disable all dates up to specific date
      };
    }
    ,
  },
  methods: {
    rowSelected(event) {
      console.log(event);
    },
    fromDateSelected(date) {
      this.customFilters[0].options.range.min = moment(date)
          .utc()
          .startOf("day")
          .toDate();
      localStorage.setItem(
          "improvements-filter-state",
          JSON.stringify(this.customFilters)
      );

      this.$store.dispatch("improvements/closeDBChannel").then(() => {
        this.openDBChannel();
      });
    },
    // @vuese
    //  sets the custom filter   date and saves this to local storage (is used to re hydrate the filter when refreshing the page)
    // @arg selected ``date``
    toDateSelected(date) {
      this.customFilters[0].options.range.max = moment(date)
          .utc()
          .endOf("day")
          .toDate();
      localStorage.setItem(
          "improvements-filter-state",
          JSON.stringify(this.customFilters)
      );

      this.$store.dispatch("improvements/closeDBChannel").then(() => {
        this.openDBChannel();
      });
    },
    deleteImprovement(data) {
      this.$swal
          .fire({
            title: this.$t("swal.delete.areyousure"),
            text:
                this.$t("swal.delete.remove") +
                ". " +
                this.$t("swal.delete.undone"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
          })
          .then((result) => {
            if (result.value) {
              this.$store.dispatch("improvements/delete", data.id).then(() => {
                this.swalToastSuccess(this.$t("ui.deleted"));
              });
            }
          });
    },
    //@vuese
    // Gets disabled dates To

    // @vuese
    // This event is needed to update the customfilters renderd via the customfilter component
    // THIS DOES NOT WORK WITH OTHER TYPE OF FILTERS YET
    // @arg `data` = values in the array
    //  @arg `idx` = index of the custom filter
    updateCustomFilter(data, idx) {
      this.customFilters[idx].options.values = data;
    },
    dateDisplay(date) {
      return moment(date).utc().format("DD/MM/YY");
    },
    /**
     * @vuese
     * Set date filters with new values from date range picker and filter table
     * @arg dateRange
     */
    updateDateRange(dateRange) {
      this.customFilters[0].options.range.min = moment(dateRange.startDate)
          .startOf("day")
          .toDate();
      this.customFilters[0].options.range.max = moment(dateRange.endDate)
          .endOf("day")
          .toDate();
      localStorage.setItem(
          "improvements-filter-state",
          JSON.stringify(this.customFilters)
      );
    },
    async openDBChannel() {
      this.$store.commit("setLoading", true);
      let where = [
        ["companyId", "==", this.getClaims.companyId],
        ["created_at", ">=", this.customFilters[0].options.range.min],
        ["created_at", "<=", this.customFilters[0].options.range.max],
      ];

      await this.$store.dispatch("improvements/openDBChannel", {where});

      this.$store.commit("setLoading", false);
    },
  },
  async beforeRouteLeave(to, from, next) {
    await this.$store.dispatch("improvements/closeDBChannel");
    next();
  },
  async created() {

    let self = this;
    this.tableInitOptions.bStateSave = false;
    // this.tableInitOptions.order = [[2, "desc"]];
    this.tableInitOptions.serverSide = false
    let filterState = localStorage.getItem("improvements-filter-state");
    if (!filterState) {
      this.customFilters[0].options.range.min = moment()
          .utc()
          .startOf("year")
          .toDate();
      this.customFilters[0].options.range.max = moment()
          .utc()
          .endOf("year")
          .toDate();
    } else {
      let parsedFilters = JSON.parse(filterState);
      _.each(parsedFilters, (filter, index) => {
        if (filter.filter == "dateRangeFilter") {
          this.customFilters[index].options.range.min = new Date(
              parsedFilters[index].options.range.min
          );
          this.customFilters[index].options.range.max = new Date(
              parsedFilters[index].options.range.max
          );
        } else {
          this.customFilters.splice(index, 1, filter);
        }
      });
    }
    this.openDBChannel();
  },
};
</script>

<style scoped>
</style>